import { render, staticRenderFns } from "./distributionMe.vue?vue&type=template&id=71474a60&scoped=true"
import script from "./distributionMe.vue?vue&type=script&lang=js"
export * from "./distributionMe.vue?vue&type=script&lang=js"
import style0 from "./distributionMe.vue?vue&type=style&index=0&id=71474a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71474a60",
  null
  
)

export default component.exports